/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Section_3_Your_2Inputs */



/**
* | output |
* | --- |
* | "Training your users on functionality and limitations" |
*
* @param {Guardrails_Section_3_Your_2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_section_3_your_2 = /** @type {((inputs?: Guardrails_Section_3_Your_2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Section_3_Your_2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Schulung Ihrer Nutzer über die Funktionsweise und Grenzen")
	return /** @type {LocalizedString} */ ("Training your users on functionality and limitations")
});